import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import { Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import "./Notification.css";
import { useNavigate, useLocation } from "react-router-dom";
import JoditEditor from "jodit-react";
import * as Yup from "yup";

import Overlay from "../../components/Overlay";
import { toast } from "react-toastify";
import { subadminAccessChange } from "../../utils/functions";
import Cookies from "js-cookie";
import { get } from "lodash";

// Mui & material UI
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Divider from "@mui/material/Divider";

import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import SearchBar from "material-ui-search-bar";

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    // TablePagination,
} from "@material-ui/core";
// React Icons
import { HiArrowNarrowLeft } from "react-icons/hi";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";

// Elements
import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    Button,
    ProfileDetailForm,
    DashHeading,
    SearchFilterContainer
} from "./NotificationManagementElements";

import Input from "../../components/Input";
import { MdMargin } from "react-icons/md";

const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        border: "1px solid rgba(17, 153, 38, 0.20)",
        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF"
    },
    textMiddle: {
        // padding: "0.4rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));


const CreateNotification = ({ setUsers, userData }) => {
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const [notification, setNotification] = useState("");
    const [isChecked, setIsChecked] = useState(false)
    const [description, setDescription] = useState("");
    const [userType, setUserType] = useState("1");

    const [selectedRows, setSelectedRows] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [userSelectionError, setUserSelectionError] = useState(false);


    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };


    const handleCheckboxChange = () => {
        setIsChecked(!isChecked)
    }

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);



    const handleSelectAll = (event) => {
        if (event.target.checked) {
            const allIds = tableData.map((user) => user._id); // Select all IDs from current page
            setSelectedRows((prevSelected) => [...new Set([...prevSelected, ...allIds])]);
        } else {
            const allIds = tableData.map((user) => user._id);
            setSelectedRows((prevSelected) => prevSelected.filter((id) => !allIds.includes(id)));
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };





    // Get all data
    useEffect(() => {
        getAllUser(page);
    }, [page, rowsPerPage, searchTerm, userType]);

    const getAllUser = async (currentPage,) => {
        setIsLoading(true);

        try {
            const { data } = await axios.get(`/private/getAllUsers?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
                userType: userType, // All => 1,  Manually=>2,  
            });

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
        } catch (error) {
            if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                console.log("error", error?.response);
            }
        } finally {
            setIsLoading(false);
        }
    };


    const handleSend = async (values) => {
        setIsLoading(true);

        // Reset any previous user selection error
        setUserSelectionError(false);

        // Validation: If userType is "2" (Manually), check if at least one user is selected
        if (values.userType === "2" && selectedRows.length === 0) {
            setUserSelectionError(true);
            setIsLoading(false);
            return; // Stop submission
        }

        let allIds = [];
        if (values.userType === "1") {
            allIds = []; // All users, backend should handle it
        } else {
            allIds = selectedRows;
        }

        const notificationSend = {
            userId: allIds,
            description: values?.description,
            title: values?.notification,
            type: values.userType, // "1" -> all, "2" -> manually
        };

        try {
            const { data } = await axios.post(
                `/private/sendNotifications`,
                notificationSend
            );

            toast.success(data?.message);
            navigate("/notificationManagement");
        } catch (error) {
            handleErrorResponse(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Error Handle
    const handleErrorResponse = (error) => {
        const status = error?.response?.status;
        const message = error?.response?.data?.message || "";

        if (status === 422) {
            toast.error(message, { position: toast.POSITION.TOP_RIGHT });
        } else if (error?.response?.status === 901) {
            subadminAccessChange(navigate);
            toast.error(`${error.response.data?.message}`, {
                position: "top-right",
            });
        } else if (status === 419) {
            localStorage.clear();
            Cookies.remove("showProfileSidebar");
            setUsers("");
            toast.error(message, { position: toast.POSITION.TOP_RIGHT });
            navigate("/");
        } else {
            toast.error(message, { position: toast.POSITION.TOP_RIGHT });
        }
    };


    const validationSchema = Yup.object().shape({
        notification: Yup.string()
            .trim()
            .matches(
                /^(?!\s*$).*$/,
                "This field cannot contain spaces. Please enter a valid value."
            ) // No empty spaces

            .min(2, "Notification must be at least 2 characters.")
            .max(30, "Notification cannot exceed 30 characters.")
            .required("Title is required.")
            .test("char-length", "Must be between 2 and 30 characters.", (value) => {
                if (!value) return true; // Allow empty field initially
                return value.length >= 2 && value.length <= 30;
            }),

        description: Yup.string()
            .transform(value => value.trim()) // Trim before validation

            .test(
                'max-chars',
                'Description cannot exceed 100 characters.',
                value => (value ? value.replace(/\s/g, '').length <= 100 : true)
            )
            .test(
                'not-empty',
                'This field cannot be empty or only spaces.',
                value => !!value && value.trim().length > 0
            )

            .required('Description is required.'),

        userType: Yup.string().required("User Type is required."),
    });



    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <div
                                style={{ cursor: "pointer" }}
                                className="d-flex align-items-center"
                                onClick={() => navigate("/notificationManagement")}
                            >
                                <HiArrowNarrowLeft style={{ fontSize: "1.2rem" }} />
                                <div className="common-heading ps-2">Create New Notification</div>
                            </div>
                        </div>

                        {/* Form Code */}
                        <DashboardHeading style={{ padding: "0" }}>
                            <Formik
                                initialValues={{
                                    notification: notification,
                                    description: description,
                                    userType: userType,
                                }}
                                validationSchema={validationSchema}
                                onSubmit={handleSend}
                            >
                                {({ values, handleChange, setFieldValue, errors, touched }) => (
                                    <Form
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "1rem",
                                        }}
                                    >
                                        <div className="faq-section">
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <div className="textNotification">
                                                    Notification Title{" "}
                                                    <span style={{ color: "red" }}>*</span>
                                                </div>
                                                <div style={{ textAlign: "right", fontSize: "1rem" }}>
                                                    {values.notification.trim()
                                                        ? values.notification.trim().length
                                                        : 0}
                                                    /30
                                                </div>
                                            </div>

                                            <Input
                                                type="text"
                                                name="notification"
                                                className="form-control "
                                                placeholder="Type Notification Title"
                                                value={values.notification}
                                                onChange={(event) => {
                                                    if (event.target.value.length <= 30) {
                                                        setFieldValue("notification", event.target.value);
                                                        setNotification(event.target.value); // Persist state
                                                    }
                                                }}
                                                maxLength={30} // Prevents typing beyond 30 characters
                                            />
                                            {errors.notification && touched.notification && (
                                                <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>
                                                    {errors.notification}
                                                </div>
                                            )}
                                        </div>

                                        <div className="faq-section">
                                            <div className="textNotification">Description</div>
                                            <JoditEditor

                                                className="custom-jodit-editor"
                                                config={{
                                                    defaultMode: '1',
                                                    placeholder: 'Enter description...', // your placeholder
                                                    style: {
                                                        fontWeight: 'normal',
                                                    },
                                                }}
                                                onBlur={(newContent) => {
                                                    const tempDiv = document.createElement("div");
                                                    tempDiv.innerHTML = newContent;
                                                    let plainText = tempDiv.textContent || tempDiv.innerText || "";
                                                    plainText = plainText.replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
                                                    console.log("Final plain text:", JSON.stringify(plainText));
                                                    setFieldValue("description", plainText);
                                                    setDescription(plainText);
                                                }}
                                            />
                                            {errors.description && touched.description && (
                                                <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>{errors.description}</div>
                                            )}
                                        </div>
                                        <div className="faq-section">
                                            <FormControl>
                                                <FormLabel>Select User Type</FormLabel>
                                                <RadioGroup
                                                    row
                                                    name="userType"
                                                    value={values.userType}
                                                    onChange={(event) => {
                                                        setFieldValue("userType", event.target.value);
                                                        setUserType(event.target.value); // Persist userType
                                                    }}
                                                >
                                                    <div className="radiobutton">
                                                        <FormControlLabel
                                                            value="1"
                                                            control={<Radio />} label="All" />
                                                        <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

                                                        <FormControlLabel
                                                            value="2"
                                                            control={<Radio onChange={() => setPage(1)} />}
                                                            label="Manually"
                                                        />
                                                    </div>

                                                    <div style={{ display: "flex", marginLeft: "auto" }}>
                                                        {values.userType !== "1" && (
                                                            <SearchBar
                                                                style={{ minWidth: "25rem", height: "44px", borderRadius: "20px", backgroundColor: "#F8F9FB", }}
                                                                className={"heightfix"}
                                                                onChange={(e) => {
                                                                    SearchAccountManagement(e);
                                                                }}
                                                                onCancelSearch={cancelSearch}
                                                                placeholder="Search by Name and Number"
                                                                inputProps={{ maxLength: 30 }}
                                                            />
                                                        )}
                                                    </div>

                                                </RadioGroup>

                                                {userSelectionError && (
                                                    <div style={{ color: "red", marginBottom: "1rem", fontSize: "14px", fontWeight: "400" }}>
                                                        Please select at least one user.
                                                    </div>
                                                )}





                                                <div style={{ marginTop: "1rem" }}>
                                                    {values.userType !== "1" && (
                                                        <>
                                                            <TableContainer
                                                                className={classes.tableMainContainer}
                                                            >
                                                                <Table className={classes.table}>
                                                                    <TableHead>
                                                                        <TableRow className={classes.tableHeadingRow}>
                                                                            <TableCell className={classes.tableHeadingCell}>
                                                                                <Checkbox
                                                                                    style={{ padding: "2px" }}
                                                                                    className={classes.tableCheckbox}
                                                                                    indeterminate={selectedRows.length > 0 && selectedRows.length < tableData.length}
                                                                                    // checked={selectedRows.length > 0 && selectedRows.length === tableData.length}
                                                                                    checked={tableData.length > 0 && tableData.every((item) => selectedRows.includes(item._id))}
                                                                                    onChange={handleSelectAll}
                                                                                    color="primary"
                                                                                // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell className={classes.tableHeadingCell}>
                                                                                S.No
                                                                            </TableCell>
                                                                            <TableCell className={classes.tableHeadingCell}>
                                                                                User Name
                                                                            </TableCell>
                                                                            <TableCell className={classes.tableHeadingCell}>
                                                                                User Number
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    {tableData && tableData.length > 0 ? (
                                                                        <>
                                                                            <TableBody>
                                                                                {tableData.map((user, index) => (
                                                                                    <TableRow className={classes.tableBodyRow} key={user._id}>
                                                                                        <TableCell className={classes.textMiddle}>
                                                                                            <Checkbox
                                                                                                style={{ padding: "2px" }}
                                                                                                checked={selectedRows.includes(user._id)}
                                                                                                onChange={() => handleSelectRow(user._id)}
                                                                                                color="primary"
                                                                                            // disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell className={classes.textMiddle} >
                                                                                            <div>
                                                                                                {index + 1 + rowsPerPage * (page - 1)}
                                                                                            </div>
                                                                                        </TableCell>
                                                                                        <TableCell className={classes.textMiddle} >
                                                                                            <div>
                                                                                                {`${get(user, "fullName", "---")}`}
                                                                                            </div>
                                                                                        </TableCell>
                                                                                        <TableCell className={classes.textMiddle} >
                                                                                            <div>
                                                                                                {`${get(user, "countryCode", "---")}`} {`${get(user, "phoneNumber", "---")}`}
                                                                                            </div>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </TableBody>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <TableBody>
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        colSpan={5}
                                                                                        align="center"
                                                                                        style={{
                                                                                            padding: "2rem",
                                                                                            borderBottom: "none",
                                                                                        }}
                                                                                    >
                                                                                        <DashHeading
                                                                                            style={{
                                                                                                textAlign: "center",
                                                                                                padding: "2rem",
                                                                                            }}
                                                                                        >
                                                                                            No Data Found !!
                                                                                        </DashHeading>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            </TableBody>
                                                                        </>
                                                                    )}
                                                                </Table>
                                                            </TableContainer>

                                                            <Stack
                                                                spacing={2}
                                                                className={classes.paginationContainer}
                                                            >
                                                                <Pagination
                                                                    count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                                                    page={page}
                                                                    onChange={(event, value) =>
                                                                        handleChangePage(event, value)
                                                                    } // Update page
                                                                    renderItem={(item) => (
                                                                        <PaginationItem
                                                                            slots={{
                                                                                previous: HiMiniArrowLeft,
                                                                                next: HiMiniArrowRight,
                                                                            }}
                                                                            {...item}
                                                                        />
                                                                    )}
                                                                />
                                                            </Stack>
                                                        </>
                                                    )}
                                                </div>
                                            </FormControl>
                                            {errors.userType && touched.userType && (
                                                <div style={{ color: "red", fontSize: "14px", fontWeight: "400" }}>{errors.userType}</div>
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "1rem",
                                            }}
                                        >
                                            <Button
                                                type="submit"
                                                disabled={isLoading}
                                                style={{ color: "#FFFFFF", background: "#5088FB" }}
                                            >
                                                Save
                                            </Button>

                                            <Button
                                                type="button"
                                                style={{
                                                    width: "130px",
                                                    backgroundColor: "#ffffff",
                                                    padding: "0.5rem 1.5rem",
                                                    color: "#26344E",
                                                    border: "1px solid #26344E38",
                                                }}
                                                onClick={() => {
                                                    navigate("/notificationManagement");
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </DashboardHeading>
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>

            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNotification);
